<template>
    <div class="footer_partagez">
        <h4>Partagez</h4>
        <div class="partagez_logos">
            <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.arnaques.biz%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">
                <button class="iconPartage facebook"></button>
            </a>

            <a target="_blank"  href="https://twitter.com/share?ref_src=twsrc%5Etfw"  data-show-count="false"><button class="iconPartage twitter"></button></a>

        </div>


        <!--    <img class ="linkedin" src="img/icon/Linkedin_w.png" alt="logo linkedin"/>-->
    </div>

</template>

<script>
export default{
      name:'Share'

  }
</script>

<style>



@media screen and (max-width:1000px){
    .footer_partagez {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 30%;


    }

    .footer_partagez h4{
        font-family: Open Sans;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 33px;
        letter-spacing: 0px;
        text-align: left;
        margin-bottom:0;
    }


    .footer_partagez p{
        font-family: Open Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: left;
        margin-bottom:0;
    }

}







</style>